function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "No results found"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { Empty } from "antd";
import { t } from "ttag";
var NotFoundContent = function(param) {
    var _param_description = param.description, description = _param_description === void 0 ? t(_templateObject()) : _param_description;
    return /*#__PURE__*/ React.createElement(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE,
        description: description
    });
};
export default NotFoundContent;
